import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Form,
  Input,
  Button,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useFormik } from "formik";
import "react-toastify/dist/ReactToastify.css";

import { useToast } from "../../Components/Common/ToastContext";
import { updateSettingsKey, viewSettingsKey } from "./_requests";
import BreadCrumb from "../../Components/Common/BreadCrumb";

const EditSettingsKey = () => {
  document.title = "Paal Dappa | Admin panel";

  const { id } = useParams();
  const { showToast } = useToast();
  const history = useNavigate();
  const [SettingsKey, setSettingsKey] = useState<any>({});

  useEffect(() => {
    viewSettingsKey(id).then((res: any) => {
      setSettingsKey(res);
    });
  }, [id]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      test_razorpay_public_key: SettingsKey.test_razorpay_public_key || "",
      test_razorpay_secret_key: SettingsKey.test_razorpay_secret_key || "",
      live_razorpay_public_key: SettingsKey.live_razorpay_public_key || "",
      live_razorpay_secret_key: SettingsKey.live_razorpay_secret_key || "",
      is_razorpay_mode_status: SettingsKey.is_razorpay_mode_status || 1,
      google_map_key: SettingsKey.google_map_key || "",
      update_type: 1
    },
    onSubmit: async (values) => {
      try {
        const res: any = await updateSettingsKey(id, values);
        if (res.status === true || res.data?.status === true) {
          toast.success(res.message || "Settings Key updated successfully", { autoClose: 3000 });
          history("/settings", { state: { activeTab: "3" } });
        } else {
          toast.error(res.message || "Failed to update Settings Key", { autoClose: 3000 });
        }
      } catch (error: any) {
        toast.error(error.message || "An error occurred", { autoClose: 3000 });
      }
    },
  });

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} limit={1} />
      <Container fluid>
            <BreadCrumb title="Create Product" pageTitle="Paal Dappa" />
        <Row>
          <Col md={12}>
            <Card>
              <CardBody>
                <h4 className="mb-4 ">Edit Settings</h4>
                <hr /> <br />
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                  }}
                >
                  <Row className="mb-3">
                    <Col md={5}>
                      <Label className="fw-bold">Razorpay Mode</Label>
                    </Col>
                    <Col md={7}>
                      <Input
                        type="select"
                        name="is_razorpay_mode_status"
                        value={validation.values.is_razorpay_mode_status}
                        onChange={validation.handleChange}
                      >
                        <option value="1">Test</option>
                        <option value="2">Live</option>
                      </Input>
                    </Col>
                  </Row>

                  {validation.values.is_razorpay_mode_status == 1 ? (
                    <>
                      <Row className="mb-3">
                        <Col md={5}>
                          <Label className="fw-bold">Razorpay Test Public Key</Label>
                        </Col>
                        <Col md={7}>
                          <Input
                            type="text"
                            name="test_razorpay_public_key"
                            value={validation.values.test_razorpay_public_key}
                            onChange={validation.handleChange}
                            placeholder="Enter Razorpay Test Public Key"
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col md={5}>
                          <Label className="fw-bold">Razorpay Test Secret Key</Label>
                        </Col>
                        <Col md={7}>
                          <Input
                            type="text"
                            name="test_razorpay_secret_key"
                            value={validation.values.test_razorpay_secret_key}
                            onChange={validation.handleChange}
                            placeholder="Enter Razorpay Test Secret Key"
                          />
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <Row className="mb-3">
                        <Col md={5}>
                          <Label className="fw-bold">Razorpay Live Public Key</Label>
                        </Col>
                        <Col md={7}>
                          <Input
                            type="text"
                            name="live_razorpay_public_key"
                            value={validation.values.live_razorpay_public_key}
                            onChange={validation.handleChange}
                            placeholder="Enter Razorpay Live Public Key"
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col md={5}>
                          <Label className="fw-bold">Razorpay Live Secret Key</Label>
                        </Col>
                        <Col md={7}>
                          <Input
                            type="text"
                            name="live_razorpay_secret_key"
                            value={validation.values.live_razorpay_secret_key}
                            onChange={validation.handleChange}
                            placeholder="Enter Razorpay Live Secret Key"
                          />
                        </Col>
                      </Row>
                    </>
                  )}

                  <Row className="mb-4">
                    <Col md={5}>
                      <Label className="fw-bold text-end">Google Map Key</Label>
                    </Col>
                    <Col md={7}>
                      <Input
                        type="text"
                        name="google_map_key"
                        value={validation.values.google_map_key}
                        onChange={validation.handleChange}
                        placeholder="Enter Google Map Key"
                      />
                    </Col>
                  </Row>

                  <div className="text-end">
                    <Button type="submit" color="success" className="me-3 w-sm">
                      Submit
                    </Button>

                    <Button type="button" color="secondary" className="w-sm" onClick={() => history("/settings")}>
                      Cancel
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EditSettingsKey;